import { lzFIsArray } from '@lz/services/Type';

export interface LzNBase {
  id: number;
  name?: string;
  is_active?: boolean;
  created_at?: string;
  created_by_id?: number;
  updated_at?: string;
  updated_by_id?: number;
  deleted_at?: string;
  deleted_by_id?: number;
  [key: string]: any;
}

export type LzTConstructorType<T = any> = new (...args: any[]) => T;

export type LzTBase = LzTConstructorType & {
  [K in keyof typeof LzMBase]: (typeof LzMBase)[K];
};

abstract class LzMBase implements LzNBase {
  id: number;
  name: string;
  is_active: boolean;
  created_at: string;
  created_by_id: number;
  updated_at: string;
  updated_by_id: number;
  deleted_at: string;
  deleted_by_id: number;
  [key: string | number | symbol]: any;

  constructor(model?: LzNBase, copyAll?: boolean) {
    if (copyAll && model) {
      for (const key in model) {
        this[key] = model[key];
      }
    }

    this.id = +(model?.id || 0);
    this.name = model?.name || '';
    this.is_active =
      typeof model?.is_active === 'undefined' ? true : !!model.is_active;
    this.created_at = model?.created_at || '';
    this.created_by_id = +(model?.created_by_id || 0);
    this.updated_at = model?.updated_at || '';
    this.updated_by_id = +(model?.updated_by_id || 0);
    this.deleted_at = model?.deleted_at || '';
    this.deleted_by_id = +(model?.deleted_by_id || 0);
  }

  static parseArray(data: any, classRef: LzTBase, ...args: any[]): LzMBase[] {
    if (!lzFIsArray(data)) {
      return [];
    }

    const out: LzMBase[] = [];

    for (const item of data) {
      out.push(new classRef(item, ...args));
    }

    return out;
  }

  static buildModel(data: any, classRef: LzTBase): LzMBase {
    const out: LzMBase = new classRef(data);

    return out;
  }

  getAttribute(key: string | number | symbol) {
    return this[key];
  }
}

export default LzMBase;
